import ability_list from '../ability/ability-list';
import type { Ability } from '../types/ability';
import type { PokemonV2 } from '../pokemon/pokemon';

const getAbilityUsageIndex = (pokemon: PokemonV2, abilityId: number): number => {
  const index = pokemon.often_used_tokusei.indexOf(abilityId);
  // よく使われる特性リストに無ければ末尾扱いにする
  return index >= 0 ? index : 999;
};

export const getAbilityById = (abilityId: number): Ability | undefined => {
  return ability_list.find((a) => a.id === abilityId);
};

export const getAbilitiesByUsage = (pokemon: PokemonV2): Ability[] => {
  return ability_list
    .filter((ability) => pokemon.ability_id_list.includes(ability.id))
    .sort(
      (a, b) => getAbilityUsageIndex(pokemon, a.id) - getAbilityUsageIndex(pokemon, b.id),
    );
};

export const getAvailableAbilities = (pokemon: PokemonV2): Ability[] => {
  if (pokemon.ability_list && pokemon.ability_list.length > 0) {
    return pokemon.ability_list;
  }
  return getAbilitiesByUsage(pokemon);
};
